import { DealerComparisonPricesPayload } from "../../queries/useGetDealerComparisonPricesByTireSize";
import { PricingAnalysisFormState } from "../../stores/slices/pricingAnalysisSlice";

export const useFilters = (
  data: DealerComparisonPricesPayload,
  { brand, season }: PricingAnalysisFormState
): DealerComparisonPricesPayload => {
  return data.filter((item) => {
    const brandFilter = brand ? item.brand === brand : true;
    const seasonFilter = season ? item.season === season : true;
    const shouldExclude = [brandFilter, seasonFilter].some(
      (predicate) => !predicate
    );
    return !shouldExclude;
  });
};
